module.exports = __webpack_public_path__ + "assets/img/b001.0e0b8266.png";